/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/account_details';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveAccountDetailsRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveAccountDetailsResponse": {
                    "fields": {
                      "accountDetails": {
                        "type": ".squareup.sfs.external.models.AccountDetails",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveAccountDetailsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveAccountDetailsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveAccountDetailsRequest @ squareup/sfs/external/services/account/retrieve_account_details.proto at 9:1
 */
export const RetrieveAccountDetailsRequest = $root.lookupType('squareup.sfs.external.service.RetrieveAccountDetailsRequest');
fixType(RetrieveAccountDetailsRequest, {
  accountId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveAccountDetailsRequest);
/**
 * SOURCE RetrieveAccountDetailsResponse @ squareup/sfs/external/services/account/retrieve_account_details.proto at 18:1
 */
export const RetrieveAccountDetailsResponse = $root.lookupType('squareup.sfs.external.service.RetrieveAccountDetailsResponse');
fixType(RetrieveAccountDetailsResponse);
Builder.createAndAttachToType(RetrieveAccountDetailsResponse);